module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/corporate-main-social-88c1b41fb52388bb9eb2725a53f96e24.jpg";